module.exports = __webpack_public_path__ + "img/icon_ghost.ae1894c5.png";